import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import User from "./User";
import Loftie from "./Loftie";
import Refurb from "./Refurb";
import NotificationCenter from "./NotificationCenter";
import Storymaker from "./Storymaker";
import AudioCenter from "./AudioCenter";
import MacLookUp from "./MacLookUp";
import SubscriptionContracts from "./SubscriptionContracts";
import NightSchool from "./NightSchool";
import SubscriptionAnalytics from "./SubscriptionAnalytics";
import DiscountAnalytics from "./DiscountAnalytics";
import FeatureAnalytics from "./FeatureAnalytics";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Tools from "./Tools";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/user",
    element: <User />,
  },
  {
    path: "/loftie",
    element: <Loftie />,
  },
  {
    path: "/tools",
    element: <Tools />,
  },
  {
    path: "/refurb",
    element: <Refurb />,
  },
  {
    path: "/notificationCenter",
    element: <NotificationCenter />,
  },
  {
    path: "/storymaker",
    element: <Storymaker />,
  },
  {
    path: "/audioCenter",
    element: <AudioCenter />,
  },
  {
    path: "/macLookUp",
    element: <MacLookUp />,
  },
  {
    path: "/subscriptionContracts",
    element: <SubscriptionContracts />,
  },
  {
    path: "/nightSchool",
    element: <NightSchool />,
  },
  {
    path: "/subscriptionAnalytics",
    element: <SubscriptionAnalytics />,
  },
  {
    path: "/discountAnalytics",
    element: <DiscountAnalytics />,
  },
  {
    path: "/featureAnalytics",
    element: <FeatureAnalytics />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
    {/* <App /> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
